module.exports = __webpack_public_path__ + "img/bungo.997f7b2.png";